import { render, staticRenderFns } from "./FatePanel.vue?vue&type=template&id=61d1c3e4&"
import script from "./FatePanel.vue?vue&type=script&lang=js&"
export * from "./FatePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports